const menu = [
    {
        icon: "icon-[mdi--apache-kafka]",
        title: "Kolaborasi",
        access: "guest",
        type: "dropdown",
        list: [
            {
                name: "surat-menyurat",
                icon: "icon-[ph--chalkboard-teacher-duotone]",
                title: "Surat Menyurat",
                access: "guest",
            },
             {
                name: "gallery",
                icon: "icon-[tabler--photo]",
                title: "Galeri",
                access: "guest",
            },
        ],
    },
    {
        icon: "icon-[mdi--book-outline]",
        title: "RIset - Clinical Research Unit",
        access: "guest",
        type: "dropdown",
        list: [
            {
                name: "cru-data",
                icon: "icon-[mdi--book-education-outline]",
                title: "Data",
                access: "guest",
            },
            {
                name: "cru-riset",
                icon: "icon-[mdi--book-search-outline]",
                title: "Riset",
                access: "guest",
            },
        ],
    },
    {
        icon: "icon-[mdi--bookshelf]",
        title: "EdukaSi",
        access: "guest",
        type: "dropdown",
        list: [ 
            {
                name: "workshop",
                icon: "icon-[mdi--account-student]",
                title: "Pelatihan - Seminar",
                access: "guest",
            },
            {
                name: "elibrary",
                icon: "icon-[mdi--library-outline]",
                title: "E-Library",
                access: "guest",
            },
            {
                name: "edukasi",
                icon: "icon-[ph--chalkboard-teacher-duotone]",
                title: "Informasi Kesehatan",
                access: "guest",
            },

        ],
    },
    {
        name: "rujukan",
        icon: "icon-[mdi--account-arrow-right-outline]",
        title: "RujukAN",
        access: "guest",
        type: "btn",
    },   

   
   
];

export default menu;
